import templateUrl from 'emun.vendor/vendor-contact-prompt.htm'
import VendorContactPromptController from 'emun.vendor/vendor-contact-prompt.controller'
//import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const VendorContactPrompt = {
    open(options) {
        const prom = modals.open(Object.assign({
            size: 'lg',
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: VendorContactPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;

        prom.then(resolve, reject);

        return prom;
    }
};

export default VendorContactPrompt;